export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const WP_BLOG_BASE_URL = 'https://learn.hapstar.app/wp-json/wp/v2';
